export const BOTTOM_MARGIN_OFFSET = 10;
export const LEFT_MARGIN_OFFSET = 16;
